import React, { useCallback, useEffect } from 'react'
import { Translation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useActions } from 'common/hooks/useActions'
import * as actions from 'client/actions/actionsManagement'
import useManagement from 'client/hooks/useManagement'
import { getSettingsEditing } from 'client/reducers/managementReducer'
import { PresentPage } from 'client/store'
import { GhostIconButton } from 'src/editor/shared/ui-lib/buttons'
import { CornerLeftUpIcon } from 'src/editor/shared/icons/corner-left-up'
import { CornerRightUpIcon } from 'src/editor/shared/icons/corner-right-up'

interface PageState {
  page: {
    present: PresentPage
    past: PresentPage[]
    future: PresentPage[]
  }
}

export const UndoRedo = () => {
  const onUndo = useActions(actions.undo)
  const onRedo = useActions(actions.redo)
  const toggleSettings = useActions(actions.toggleSettings)

  const settingsEditing = useManagement(getSettingsEditing)
  const page = useSelector((state: PageState) => state.page)
  const canUndo = page?.past.length > 1 // xhr data is 0 index
  const canRedo = page?.future.length > 0

  useEffect(() => {
    document.onkeydown = e => {
      if (e.keyCode === 90 && (e.ctrlKey || e.metaKey) && canUndo) {
        if (settingsEditing.id) {
          toggleSettings(null)
        }
        onUndo()
      }
    }
  }, [])

  const undo = useCallback(() => {
    if (settingsEditing.id) {
      toggleSettings(null)
    }

    onUndo()
  }, [settingsEditing.id, onUndo, toggleSettings])

  return (
    <Translation>
      {t => (
        <React.Fragment>
          <GhostIconButton
            onClick={undo}
            disabled={!canUndo}
            title={t('core.history.undo.title')}
            icon={<CornerLeftUpIcon />}
          />
          <GhostIconButton
            onClick={onRedo}
            disabled={!canRedo}
            title={t('core.history.redo.title')}
            icon={<CornerRightUpIcon />}
          />
        </React.Fragment>
      )}
    </Translation>
  )
}
